export const blockIconsSearchBed = (
	<span className='material-symbols-outlined'>bed</span>
);
